<template>
    <div class="content">
        <h3 ref="pageHeader" class="pageHeader">安全承诺书列表</h3>
        <!-- <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
      </el-form>
    </div> -->
        <div>
            <custom-table :data="tableData" border style="width: 100%">
                <custom-table-column fixed label="序号" type="index" width="50">
                </custom-table-column>
                <custom-table-column prop="student_name" label="学生姓名">
                </custom-table-column>
                <custom-table-column prop="number" label="学号">
                </custom-table-column>
                <custom-table-column prop="status" label="签字状态">
                </custom-table-column>
                <custom-table-column prop="signed_at" label="签字时间">
                </custom-table-column>
                <custom-table-column fixed="right" label="操作" width="100">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.status == '已签署' && scope.row.signature_url"
                            @click="handleDownload(scope.row.signature_url)" type="text" size="small">下载</el-button>
                        <el-button v-if="scope.row.status == '已签署'" @click="handleView('view',scope.row)" type="text"
                            size="small">预览</el-button>
                        <el-button v-else @click="handleView('sign',scope.row)" type="text" size="small">签字</el-button>
                    </template>
                </custom-table-column>
            </custom-table>
            <div class="pageLine">
                <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
            </div>
        </div>
        <el-dialog :close-on-click-modal="false" title="安全承诺书" :visible.sync="detailDialogVisible" width="706px">
            <CommitmentSign ref="sign" :signType="signType" :studentId="student_id"></CommitmentSign>
        </el-dialog>
    </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinOrgan } from '@/assets/js/mixin/organization';
import CommitmentSign from './commitmentSign.vue'

export default {
    name: 'trainingRoom',
    mixins: [mixinList, mixinOrgan],
    data() {
        return {
            formInline: {
                title: '',
                post: '',
            },
            detailDialogVisible: false,
            levell: [1, 2],
            centerDialogVisible: false,
            total: 0,
            tableData: [],
            signType:'view',
            student_id:'',
        };
    },
    components: {
        CommitmentSign
    },
    created() {
    },
    mounted() {
    },
    methods: {
        handleView(status,row) {
            this.signType = status;
            this.student_id = row.student_id
            this.detailDialogVisible = true;
            this.$nextTick(() => {
                this.$refs.sign.getPdfFile()
            });
        },
        handleDownload(url) {
            location.href = url;
        },
        handleQuery() {
            this.$refs.pageChild.page = 1;
            this.getList();
        },

        async getList() {
            let params = this.$until.deleteNullPrototype(this.formInline);
            params.page = this.$refs.pageChild.page;
            params.size = this.$refs.pageChild.size;
            let res = await this.$api.instance.interfaceServer('api/safety_commitment/list', 'get', params);
            if (res.code == 0 && res.data) {
                this.tableData = res.data.data;
                this.total = res.data.total;
            }
        },
    },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
    width: var(--width);
}
</style>
